import { AppContext } from "@components/features/appContext/AppContext";
import Layout from "@components/primitives/layout/Layout";
import { createTitle } from "@utils/config";
import { translation } from "@utils/translation";
import { useContext } from "react";
import { Helmet } from "react-helmet-async";
import Icon from "@components/primitives/icon/Icon";
import Socials from "@components/features/socials/Socials";

type Props = {
  isPage?: boolean;
};

function ConstructionPage({ isPage }: Props) {
  const { language } = useContext(AppContext);

  return (
    <Layout>
      <div className="h-screen w-screen flex flex-col gap-10 justify-center items-center bg-primary">
        <Helmet>
          <title>{createTitle(translation(language).construction.title)}</title>
        </Helmet>
        <Icon
          className="md:h-[175px] h-[125px] text-yellow-500"
          icon="helmet-safety"
        />
        <div className="flex flex-col justify-center items-center gap-2 text-center px-5 ">
          <h1 className="text-primary font-bold text-4xl">
            {translation(language).construction.title}
          </h1>
          <h3 className="text-secondary text-xl">
            {isPage
              ? translation(language).construction.pageDescription
              : translation(language).construction.description}
          </h3>
        </div>
        <Socials />
      </div>
    </Layout>
  );
}

export default ConstructionPage;
